import { ActorRole, DealState } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

import { dealStateState } from './deal-state.state';
import { editionModeState } from './edition-mode.state';

export type DealDisplayStatus =
  | 'empty'
  | 'importing'
  | 'choose_editing'
  | 'brand_editing'
  | 'closed';

export const dealDisplayStatusAtom = atom<DealDisplayStatus | null>((get) => {
  const dealState = get(dealStateState);
  const editionMode = get(editionModeState);

  if (!dealState || !editionMode) return null;

  if (dealState === DealState.Empty) return 'empty';
  if (dealState === DealState.ScrapingInProgress) return 'importing';
  if (dealState === DealState.NegotiationClosed) return 'closed';

  return editionMode === ActorRole.Brand ? 'brand_editing' : 'choose_editing';
});
